import { render, staticRenderFns } from "./BrandPage.vue?vue&type=template&id=b99cf574&"
import script from "./BrandPage.vue?vue&type=script&lang=js&"
export * from "./BrandPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports